import resource from '../resource';

export const verificationListApi = resource(`/basket-manual-check/`);
export const verificationActionApi = (session_id: any) =>
  resource(`/manual-check/${session_id}/`);
// change way of passing params to api
// Eg : url/:session_id
